import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(public)/(main-layout)/publication/')({
  loader: () => {
    throw redirect({ to: '/publication/list', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
